import React from "react";
import { ColDef, GetRowStyle, RowStyle } from "ag-grid-community";
import { useHistory } from "react-router-dom";
import { ModalTypes } from "constants/navigation";
import { colors } from "constants/theme";
import { getHashModalRoute } from "lib/navigation";
import AgGridContainer from "components/AgGrid/AgGridContainer";
import {
  NlisFileColumnDefinitions,
  type NlisFileRow,
} from "constants/columnDefinitions/nlisFile";

interface NLISFileGridProps {
  rowData: NlisFileRow[];
  tableName: string;
}

interface NLISFileGridContext extends Record<string, unknown> {
  handleViewAction: (transfer: NlisFileRow) => void;
}

const getRowStyle: GetRowStyle<NlisFileRow, NLISFileGridContext> = ({
  data,
}): RowStyle | undefined => {
  if (!data) {
    return undefined;
  }

  const { eidSuccessCount, eidCount } = data;
  if (eidSuccessCount !== eidCount) {
    return {
      background: `${colors.warningOrange}50`,
    };
  }

  return undefined;
};

export const NLISFileGrid = React.memo(
  ({ rowData, tableName }: NLISFileGridProps) => {
    const history = useHistory();

    const openReceipt = React.useCallback(
      (transfer: NlisFileRow) => {
        const { id, transferType } = transfer;
        const params = {
          modalType: ModalTypes.NLISTransferReceipt,
          queryArray: [id, transferType],
        };

        history.push(`#${getHashModalRoute(params)}`);
      },
      [history],
    );

    const context = React.useMemo<NLISFileGridContext>(() => {
      return { handleViewAction: openReceipt };
    }, [openReceipt]);

    const columnDefs = React.useMemo<ColDef<NlisFileRow>[]>(
      () => Object.values(NlisFileColumnDefinitions),
      [],
    );

    return (
      <AgGridContainer
        hideHeader={true}
        rowData={rowData}
        columnDefs={columnDefs}
        tableName={tableName}
        context={context}
        getRowStyle={getRowStyle}
      />
    );
  },
);
